module.exports = __webpack_public_path__ + "img/rightArrow.d676852b.svg";